
// モジュールを読込.
import { Options, Prop, Vue, Watch } from "vue-property-decorator"
import axios from "axios"
import Util from "packs/utils/Util"
import isMobile from "ismobilejs"
import { DateTime } from "luxon"
import { Logger, funcName } from "packs/common"
import { gtagLog, gtagClick, gtagPage } from "packs/GoogleTagManager"

// コンポーネントを読込.
import ChukaiSidebarMenu from "packs/pages/link/ChukaiSidebarMenu.vue"
import FlashNotice from "packs/components/common/FlashNotice.vue"
import RoomsLoader from "packs/components/loader/RoomsLoader.vue"
import SelectTag from "packs/components/forms/SelectTag.vue"
import AlertBadge from "packs/components/icons/AlertBadge.vue"
import ProgressCell from "packs/pages/link/parts/ProgressCell.vue"
import RoomHistoryDetailModal from "packs/pages/link/modals/RoomHistoryDetailModal.vue"
import RemindModal from "packs/pages/link/modals/RemindModal.vue"
import AnsweredFormModal from "packs/pages/link/parts/room_summary/AnsweredFormModal.vue"

// モデルを読込.
import Room from "packs/models/Room"
import RoomManager from "packs/models/RoomManager"
import RoomMember from "packs/models/RoomMember"
import Notice from "packs/models/Notice"
import RoomStorage from "packs/models/RoomStorage"
import SubscriptionManager from "packs/models/SubscriptionManager"
import Report from "packs/models/Report"
import Const from "packs/utils/Const"
import RoomHistoryManager from "packs/models/RoomHistoryManager"
import UserPermissionsOption from "packs/models/UserPermissionsOption"
import RoomTab from "packs/models/RoomTab"

const roomStorage = new RoomStorage()

@Options({
    components: {
        FlashNotice,
        ChukaiSidebarMenu,
        RoomsLoader,
        ProgressCell,
        SelectTag,
        AlertBadge,
        RoomHistoryDetailModal,
        RemindModal,
        AnsweredFormModal,
    },
})
export default class Progresses extends Vue {
    // data:
    notice = Notice

    rm = RoomManager
    mem = RoomMember
    isSP = isMobile(window.navigator).phone

    subm = SubscriptionManager
    hm = RoomHistoryManager
    historyRoom: Room = null

    // 確定済みは、スケジュールから確認できるため、このページでは取得しません。
    filterDic = { all: `すべて`, start_appointment: `調整中(未提案)`, suggested: `提案済み` }
    filterNameArray: string[] = Object.values(this.filterDic)
    selectedFilterName: string = `all` // all / start_appointment / suggested

    Const = Const

    currentRooms: Room[] = null
    userFilter: string = `self` // self / all

    Util = Util
    UserPermissionsOption = UserPermissionsOption

    loading = false

    // リマインドモーダル
    selectedUsers: RoomMember[] = []
    selectedRooms: Room[] = []
    selectedParg: string = null
    selectedLpId: string = null

    // フォーム確認モーダル
    selectedMember: RoomMember = null
    selectedRoom: Room = null

    blockingTabs = false

    public mounted() {
        gtagPage(`#/progresses`)
        try {
            let [uf, tabname] = roomStorage.fetchProgressTab()
            this.userFilter = uf || `self`
            this.selectedFilterName = tabname || `all`
        } catch (e) {
            Logger(`${funcName()} 進捗管理画面のタブ情報を取得できませんでした.`)
        }
        let tabs = this.rm.roomTabs
        let rooms = tabs ? tabs[this.userFilter]?.active_in_progress?.rooms : null
        if (rooms) {
            this.checkPermission()
            if (!Const.paidOverBussiness(this.rm)) {
                this.$router.push(`/`)
                return
            }
            if (this.rm.userInfo.user_group_role == Const.UserGroupRole.member) {
                this.$router.push(`/`)
                return
            }

            // ルーム情報にある進捗状況を一覧にして表示します。
            this.selectFilter(this.selectedFilterName)
        } else {
            this.rm.getAvailableSchedule().then(e => {
                this.checkPermission()
                if (!Const.paidOverBussiness(this.rm)) {
                    this.$router.push(`/`)
                    return
                }
                if (this.rm.userInfo.user_group_role == Const.UserGroupRole.member) {
                    this.$router.push(`/`)
                    return
                }

                this.selectFilter(this.selectedFilterName)
            })
        }
    }

    /**
     * メンバーを選択して、表示を変更します。
     */
    filterUser(e) {
        Logger(`filterUser ${e}`)
        if (e == `全体`) {
            this.userFilter = `all`
        } else {
            this.userFilter = `self`
        }

        this.selectFilter(this.selectedFilterName)
    }

    selectFilterName(e) {
        this.selectedFilterName = Object.keys(this.filterDic).find(key => this.filterDic[key] == e)
        this.selectFilter(this.selectedFilterName)
    }

    selectFilter(e) {
        Logger(`${funcName()} e:${e}`)
        if (e == `all`) {
            let rooms = this.rm.roomTabs[this.userFilter]?.active_in_progress?.rooms || []
            if (rooms.length > 0) {
                this.currentRooms = [...rooms]
            } else {
                this.getRooms(this.userFilter, `active_in_progress`)
            }
        } else if (this.filterDic[e]) {
            let rooms = this.rm.roomTabs[this.userFilter]?.active_in_progress?.rooms || []
            if (rooms.length > 0) {
                if (e == `start_appointment`) {
                    rooms = rooms.filter(r => (r.shared_schedule_member_ids || []).length == 0)
                } else if (e == `suggested`) {
                    rooms = rooms.filter(r => (r.shared_schedule_member_ids || []).length > 0)
                }
                this.currentRooms = rooms
            } else {
                this.getRooms(this.userFilter, `active_in_progress`)
            }
        }
        // } else {
        //     /**
        //      * `すべて`,
        //         `< メール開封済み`,
        //         `< 入室済み`,
        //         `入室済み ≦ 未確定`,
        //      */

        //     if (e == `< メール開封済み`) {
        //         this.currentRooms = this.currentRooms.filter(r => {
        //             if (r.status == 101) {
        //                 let histLarges = Object.values(r.progress_member_dic)
        //                 // const invs = r.invitations || []
        //                 if (
        //                     histLarges.some(
        //                         histLarge => histLarge.mail && histLarge.mail.create_room && !histLarge.mail.create_room.open
        //                     )
        //                 )
        //                     return r
        //             }
        //         })
        //     } else if (e == `< 入室済み`) {
        //         this.currentRooms = this.currentRooms.filter(r => {
        //             if (r.status == 101) {
        //                 let histLarges = Object.values(r.progress_member_dic)
        //                 // const invs = r.invitations || []
        //                 if (histLarges.some(histLarge => histLarge && histLarge.room && !histLarge.room.enter)) return r
        //             }
        //         })
        //     } else if (e == `入室済み ≦ 未確定`) {
        //         this.currentRooms = this.currentRooms.filter(r => {
        //             if (r.status == 101) {
        //                 let histLarges = Object.values(r.progress_member_dic)
        //                 // const invs = r.invitations || []
        //                 if (histLarges.some(histLarge => histLarge.room && histLarge.room.enter && !histLarge.schedule.share))
        //                     return r
        //             }
        //         })
        //     } else {
        //         this.filterUser(`全体`)
        //     }
        // }
        // this.selectedFilterName = this.filterDic[e]
        roomStorage.saveProgressTab(`${this.userFilter}/${this.selectedFilterName}`)
    }

    public showHistory(room: Room) {
        this.rm.startProgress()
        if (this.loading) return
        this.loading = true
        this.hm.resetData()
        this.hm.getHistory(room, false).then(hists => {
            this.historyRoom = room
            this.$vfm.open("RoomHistoryDetailModal")
            this.rm.endProgress()
            this.loading = false
        })
    }

    checkPermission() {
        if (UserPermissionsOption.permitDisplay(this.rm.userInfo, `reports`, `progresses`)) {
            return
        }
        if (UserPermissionsOption.permitDisplay(this.rm.userInfo, `reports`, `reports`)) {
            this.$router.push(`/reports`)
            return
        }

        this.$router.push(`/`)
    }

    // リマインドモーダルを開きます.
    clickRemind(mem: RoomMember, room: Room) {
        Logger(`${funcName()} mem:${mem.user_id} room:${room.id}`)
        this.selectedUsers = [mem]
        this.selectedRooms = [room]
        this.selectedParg = null
        this.selectedLpId = null
        this.$nextTick(() => {
            this.$vfm.open("RemindModal")
        })
    }

    // フォーム確認モーダルを開きます.
    clickFormMember(mem: RoomMember, room: Room) {
        this.selectedMember = mem
        this.selectedRoom = room
        // フォーム確認
        this.$nextTick(() => {
            this.$vfm.open(`AnsweredFormModal`)
        })
    }

    // フォーム確認モーダルのメンバーを更新します.
    updateMember(mem: RoomMember) {
        ;(this.currentRooms || []).forEach(r => {
            if (r.id == mem.parent_room_id) {
                let _mem = r.members.find(m => m.id == mem.id)
                if (_mem) {
                    Object.assign(_mem, mem)
                }
            }
        })
    }

    /**
     * スクロールを検知して、下までいったらルーム情報を取得します。
     */
    public scroll() {
        Logger(`${funcName()}`)

        if ($(".roomTableContent").outerHeight() < window.innerHeight + window.scrollY) {
            Logger(`${funcName()} 下端までスクロール uf:${this.userFilter}`)
            let currentTab = this.rm.roomTabs[this.userFilter][`active_in_progress`] as RoomTab
            if (Util.isBlank(currentTab)) {
                return
            }

            if (currentTab.has_next) {
                if (this.blockingTabs) return
                // 取得中の切り替え防止.
                this.blockingTabs = true

                this.getRooms(this.userFilter, `active_in_progress`)
            } else {
                Logger(`これ以上取得するものはありません.`)
            }
        }
    }

    public getRooms(uf: string, tabname: string) {
        Logger(`${funcName()} uf:${uf}, tabname:${tabname}`)
        this.startProgress()
        this.rm.getRooms(uf, tabname).then(val => {
            this.blockingTabs = false
            this.endProgress()
            if (!val) return

            let rooms = val.rooms as Room[]
            const tab = val.tab as RoomTab
            Logger(`データ取得: rooms.length:${rooms.length}, tab.tab_name:${tab.tab_name}, uf:${uf}`)

            let type = uf

            if (type == tab.user_filter) {
                // タブの表示ルールに従って並び替えます。
                rooms = RoomTab.sortRoomsWithTabName(rooms, tab.tab_name)
                if (this.selectedFilterName == `all`) {
                    this.currentRooms = rooms
                } else {
                    let rooms = this.rm.roomTabs[this.userFilter][`active_in_progress`].rooms || []
                    if (this.selectedFilterName == `start_appointment`) {
                        this.currentRooms = [...rooms.filter(r => (r.shared_schedule_member_ids || []).length == 0)]
                    } else if (this.selectedFilterName == `suggested`) {
                        this.currentRooms = [...rooms.filter(r => (r.shared_schedule_member_ids || []).length > 0)]
                    }
                }
            }
        })
    }

    startProgress() {
        this.rm.startProgress()
    }

    endProgress() {
        this.rm.endProgress()
    }

    goSummaryFromParent(room: Room) {
        let pubId = room.public_room_id
        if (!pubId) return
        if (this.loading) return
        this.loading = true

        this.getRoomAndDisplay(pubId, `public_room`)
    }

    /**
     * 調整ページに紐づく情報を取得してきます.
     */
    getRoomAndDisplay(roomId, roomType, tabName = `active_in_progress`, page = null) {
        Logger(`${funcName()} roomId:${roomId}, roomType:${roomType}, tabName:${tabName}, page:${page}`)

        let allRooms = this.rm.roomTabs[`all`]?.public?.rooms || []
        let selfRooms = this.rm.roomTabs[`self`]?.public?.rooms || []

        let totalRooms = [...allRooms, ...selfRooms]
        if (totalRooms.length > 0) {
            let room = totalRooms.find(r => r.id == roomId)
            if (room) {
                // すでにルーム情報があるため、そのまま遷移します.
                Logger(`${funcName()} すでにルーム情報があるため、そのまま遷移します. roomId:${roomId}`)
                roomStorage.save(null)
                roomStorage.saveAppointment(null)
                roomStorage.saveSelectedRoomKey(null)
                this.rm.currentRoom = room
                this.$router.push("/pub_summary")
                return
            }
        }

        this.rm.startProgress()
        // showのときしか入っていないパラメータがあるため、詳細情報を取得します。
        this.rm.getRoom(roomId, roomType, tabName, page).then(room => {
            this.loading = false
            this.blockingTabs = false
            this.rm.endProgress()

            // 新たに取得した情報があるため、最終結果を保存しておきます.
            roomStorage.save(null)
            roomStorage.saveAppointment(null)
            roomStorage.saveSelectedRoomKey(null)
            this.rm.currentRoom = room

            // 今の限定公開ページがあるタブに移動
            if (room.room_type == `public_room`) {
                this.$router.push("/pub_summary")
            } else {
                this.$router.push("/summary")
            }
        })
    }
}
